import React, { useMemo } from "react"
import ReactEcharts from "echarts-for-react"
import ChatCharts from "@sui/rc-chat-charts"
import { Card } from "antd"

/* 
    饼状图
    我要的data数据
    {
        label:name[],
        series:{name,value}[]
    }
*/
const aaa = [
  {
    YXMC: "食品与生物工程学院",
    已就业人数: "558",
    总人数: "561",
  },
  {
    YXMC: "美术与设计学院",
    已就业人数: "271",
    总人数: "578",
  },
  {
    YXMC: "外国语学院",
    已就业人数: "323",
    总人数: "326",
  },
  {
    YXMC: "材料科学与工程学院",
    已就业人数: "523",
    总人数: "523",
  },
  {
    YXMC: "航空航天学院",
    已就业人数: "22",
    总人数: "140",
  },
  {
    YXMC: "四川交通职业技术学院",
    已就业人数: "102",
    总人数: "103",
  },
  {
    YXMC: "能源与动力工程学院",
    已就业人数: "323",
    总人数: "323",
  },
  {
    YXMC: "四川建筑职业技术学院",
    已就业人数: "52",
    总人数: "52",
  },
  {
    YXMC: "计算机与软件工程学院",
    已就业人数: "824",
    总人数: "828",
  },
  {
    YXMC: "国际经济与管理研究院",
    已就业人数: "15",
    总人数: "15",
  },
]

const PieChart = (props) => {
  const { chatInstance, msg } = props
  const [dataset, chartProps] = useMemo(() => {
    const data = msg?.chart?.data?.data || msg.chart?.data || []
    console.log(msg, "图表数据，过滤条件")
    const chartProps = {}
    const keys = Object.keys(data[0] || {})
    const dims = keys.slice(1)
    let selected = {}
    if (dims.length > 1) {
      dims.forEach((dim, index) => {
        // 默认选中最后一个指标
        selected[dim] = index === dims.length - 1
      })
    }
    chartProps.baseChartOption = {
      legend:
        dims.length > 1
          ? {
            selected: selected,
          }
          : undefined,
    }
    return [data || [], chartProps]
  }, [msg?.chart?.data])
  const option = useMemo(
    () => ({
      title: {
        text: msg?.chart?.data?.title,
        // subtext: msg?.chart?.data?.title,
        left: "center",
        // subtextStyle: {
        //   left: "10px",
        // },
      },
      tooltip: {
        trigger: "item",
      },
      legend: {
        // icon: "circle",
        top: "10%",
        // orient: 'vertical',
        // x: "left",
        // y: "center",
        // itemGap: 14,
        // formatter: (a: any) => {
        //   let newA;
        //   msg?.data?.data?.forEach((item: any) => {
        //     if (item.name === a) {
        //       newA = item.name + "\t\t" + item.value + "人/次";
        //       // newA = item.value + '人/次';
        //       return;
        //     }
        //   });
        //   return newA || a;
        // },
      },
      series: [
        {
          name: msg?.chart?.data?.title,
          type: "pie",
          radius: "50%",
          // radius: ['38%', '65%'],
          // avoidLabelOverlap: false,
          // itemStyle: {
          //   borderRadius: 10,
          //   borderColor: "#fff",
          //   borderWidth: 2,
          // },
          label: {
            formatter: "{b}: {d}%",
          },
          tooltip: {
            formatter: "{b}: {d}%（ {c}）",
          },
          // label: {
          //     show: false,
          //     position: 'center'
          // },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
          // emphasis: {
          //   label: {
          //     show: true,
          //     fontSize: 40,
          //     fontWeight: "bold",
          //   },
          // },
          labelLine: {
            length: 5,
            length2: 5,
            // show: false
          },
          data: msg?.chart?.data?.data || [],
        },
      ],
    }),
    [msg?.chart?.data]
  )
  return (
    <Card style={{ margin: "12px" }}>
      <ChatCharts
        title={msg?.chart?.title}
        defaultDisplayType={msg?.chart?.type}
        {...chartProps}
        dataset={dataset}
        filterTags={msg?.chart?.selectfilters?.map((item) => {
          return {
            label: item.name,
            value: item.value
          }
        })}
      />
    </Card>
  )
}

export default PieChart
